import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
import styles from './IconBadgeControl.module.scss';
export var IconBadgeControl = function (_a) {
    var liveBadge = _a.liveBadge, staticBadge = _a.staticBadge;
    var _b = __read(useState(staticBadge !== null && staticBadge !== void 0 ? staticBadge : ''), 2), badge = _b[0], setBadge = _b[1];
    useEffect(function () {
        var subscription = liveBadge === null || liveBadge === void 0 ? void 0 : liveBadge.subscribe(function (newBadge) {
            if (badge !== newBadge) {
                setBadge(newBadge);
            }
        });
        return function () {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, [badge, liveBadge]);
    useEffect(function () {
        staticBadge && setBadge(staticBadge);
    }, [staticBadge]);
    return badge.length > 0 ? (React.createElement("div", { className: styles['badge'] },
        React.createElement("div", { className: styles['badge__text'] }, badge))) : null;
};
//# sourceMappingURL=IconBadgeControl.js.map